import React from 'react';
import './FloatingWhatsApp.css';
import { WA_CS_LINK } from '../config/whatsapp';

const FloatingWhatsApp = () => {
    return (
        <a
            href={WA_CS_LINK}
            className="floating-whatsapp"
            target="_blank"
            rel="noopener noreferrer"
        >
            <img src="/whatsapp-icon.png" alt="WhatsApp" />
        </a>
    );
};

export default FloatingWhatsApp;
